// ENG-22077: set by updatePlugin() when /version reports a release this bundle isn't.
// Read by the dynamic-component loader, which may only reload a tab when a newer bundle
// actually exists to reload into -- during the backend-first deploy window it does not.
let newVersionAvailable = false;

export function markNewVersionAvailable() {
  newVersionAvailable = true;
}

export function isNewVersionAvailable() {
  return newVersionAvailable;
}
